module.exports = __webpack_public_path__ + "img/security-audit-img-6.9c244d7b.png";